import { ReactComponent as tactileoGoLogo } from './assets/tactileoGo/logo.svg';
import { ReactComponent as marocLogo } from './assets/maroc/logo.svg';
import { ReactComponent as imagineEcoleLogo } from './assets/imagineEcole/logo.svg';

export const logoMap = {
  tactileoGo: tactileoGoLogo,
  maroc: marocLogo,
  imagineEcole: imagineEcoleLogo,
};
interface themeType {
    id: string;
    name: string;
    class: string;
    lang: string;
}

export interface themesType {
    tactileoGo: themeType;
    imagineEcole: themeType;
    maroc: themeType;
}

export const themes : themesType = {
    tactileoGo: {
        id: 'tactileoGo',
        name: 'Tactileo GO',
        class: '',
        lang: 'fr'
    },
    imagineEcole: {
        id: 'imagineEcole',
        name: 'Imagine Ecole',
        class: 'imagineEcole',
        lang: 'fr'
    },
    maroc: {
        id: 'maroc',
        name: 'Maroc',
        class: 'maroc',
        lang: 'ar'
    }

};
